<template>
  <div :style="{height:height}">
    <div class='cube-word-template-render border-bottom'>
      <div class="cube-word-template-render-office">
        <cube-only-office v-bind="$attrs" :callback-url="callbackUrl" :load-token="loadToken" :config="configByClone" v-on="$listeners" @onload="onOnlyOfficeLoad" />
      </div>
      <div v-if="onlyOfficeLoad"  class="cube-word-template-render-form">
        <div class="form-header">
          <span>必填：{{requiredNum.min}}/{{requiredNum.max}}</span>
          <span>非必填：{{freeNum.min}}/{{freeNum.max}}</span>
        </div>
        <div class="form-body border-top ">
          <el-form ref="form" :model="form" :rules="rules">
            <cube-form-item
              v-for="(i,index) in labelList"
              :key="index"
              :custom-width="23"
              :label="i.name"
              :prop="i.id"
              :error-msg="error[i.id]"
              >
              <bridge
              v-model="form[i.id]"
              :label-item="i"
              @upload-success="uploadImg"
              />
            </cube-form-item>
          </el-form>
        </div>
      </div>
  </div>
    <div class="cube-word-template-render-bottom">
      <cube-button type="primary" @click="exportDoc">导出</cube-button>
    </div>
  </div>
</template>

<script>
import bridge from './components/index'
import { deepClone } from '@cndinfo/cube-web-utils'
import { createTemplateRenderData } from './utils/index.js'
import '../../../../lib/styles/components/WordTemplateRender.scss'
export default {
  name: 'WordTemplateRender',
  components: {
    bridge
  },
  props: {
    labelList: {
      type: Array,
      default: () => {
        return []
      }
    },
    height: {
      type: String,
      default: '100%'
    },
    config: {
      type: Object,
      default: () => {
        return {}
      }
    },
    callbackUrl: {
      type: String,
      default: ''
    },
    loadToken: {
      type: Function,
      default: () => { }
    }
  },
  data() {
    return {
      onlyOfficeLoad: false,
      form: {},
      rules: {},
      error: {},
      configByClone: {},
      imageTypeInfo: {},
      exportUrl: 'system/contract/template/fill',
      requiredNum: {
        min: 0,
        max: 0
      },
      freeNum: {
        min: 0,
        max: 0
      }
    }
  },
  watch: {
    form: {
      handler(value) {
        this.computedFormFill(value)
        this.$emit('onFormDataChange', value)
      },
      deep: true
    }
  },
  created() {
    this.$set(this, 'configByClone', deepClone(this.config))
    this.normalizeForm()
  },
  methods: {
    computedFormFill(value) {
      let requiredMin = 0
      let freeMin = 0
      this.labelList.forEach(item => {
        const { id, required } = item
        const v = value[id]
        const finishValue = v !== undefined && v !== null && v.length
        if (required && finishValue) {
          requiredMin++
        } else if (!required && finishValue) {
          freeMin++
        }
      })
      this.requiredNum.min = requiredMin
      this.freeNum.min = freeMin
    },
    onOnlyOfficeLoad(editor) {
      this.onlyOfficeLoad = true
      this.$emit('load', editor)
    },
    exportDoc() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const { config, labelList, form, imageTypeInfo } = this
          const data = createTemplateRenderData(config, labelList, form, imageTypeInfo)
          this.$emit('export', data)
          // request({
          //   url: this.exportUrl,
          //   method: 'POST',
          //   noLoading: true,
          //   data
          // }).then(res => {
          //   window.open(res.data)
          // })
        }
      })
    },
    normalizeForm() {
      const createRule = (labelItem) => {
        const { required, trigger, message, name, type, id } = labelItem
        if (required) {
          this.requiredNum.max++
        } else {
          this.freeNum.max++
        }
        const rule = {
          required,
          trigger: trigger || 'blur',
          message: message || `${name}为必填项`
        }
        this.$set(this.error, id, rule.message)
        if (type === 'table') {
          rule.validator = (rule, value, callback) => {
            if (!this.form[id]) {
              return callback(new Error())
            }
            // 表格数据
            callback()
          }
        }
        return [
          rule
        ]
      }
      const normalizeValue = value => {
        if (Array.isArray(value) || value instanceof Object) {
          return JSON.parse(JSON.stringify(value))
        }
        return value
      }
      this.labelList.forEach((labelItem) => {
        const { id, defaultValue = null } = labelItem
        if (!id) {
          return console.error('labelItem.id属性为:', id)
        } else {
          this.$set(this.form, id, normalizeValue(defaultValue))
          this.$set(this.rules, id, createRule(labelItem))
        }
      })
      this.$nextTick(() => {
        this.computedFormFill(this.form)
      })
    },
    uploadImg(res) {
      const { item: { id }, data } = res
      this.$set(this.imageTypeInfo, id, data)
    }
  }
}
</script>
